const throttle = require('lodash/throttle');

/**
 *
 * @description Предотвращает повторные клики по стрелкам навигации во время прокрутки слайдера.
 * Без данного метода слайдер работает некорректно.
 */
export function preventDoubleClick(fn: () => void, sliderAnimationTime: number): () => void {
  return throttle(fn, sliderAnimationTime * 1000, { leading: true, trailing: false });
}
